import { instance } from '../config';
import axios from 'axios';

export default function searchDataset({ q }) {
  return instance.get(`/search?q=${encodeURIComponent(q)}`);
}

// new API call
export function queryDataset({ q }) {
  let data = JSON.stringify({
    query: q,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_KWERTY_AI_URL}/query/data_search`,
    headers: {
      Authorization: `Bearer ${process.env.VUE_APP_KWERTY_BEARER_TOKEN}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };

  return axios(config);
}

export function queryAnalysis(q) {
  let data = JSON.stringify(q);

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_KWERTY_AI_URL}/query/analyze_data`,
    headers: {
      Authorization: `Bearer ${process.env.VUE_APP_KWERTY_BEARER_TOKEN}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };

  return axios(config);
}
